<template>
  <Box class="box-container">
    <div class="header">
      <h3>Top instrutores</h3>

      <MiniSelect :options="months" :modelValue="selectedMonth" @update:modelValue="updateModelValue"
        :disabled="loadingTable" />
    </div>

    <div v-if="loadingTable" class="loading">
      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
      </component>
    </div>

    <div v-else class="content">
      <div class="header">
        <span>Instrutor</span>
        <span>Aulas</span>
      </div>

      <div v-if="ranks.length" class="body">
        <div class="list-item" v-for="rank in ranks" :key="rank.id">
          <i class="fa fa-user-circle"></i>
          <span class="name">{{ rank.instrutor }}</span>
          <span class="count">{{ rank.aulas_realizadas }}</span>
        </div>
      </div>

      <div class="empty-body" v-else>
        <span>Sem resultados</span>
      </div>
    </div>
  </Box>
</template>

<script>
import * as spinners from 'epic-spinners'
import Box from 'core/Box.vue';
import urlApi from '@/router/urlApiV2'
import MiniSelect from 'core/MiniSelect.vue';

export default {
  name: 'RankInstrutores',
  components: {
    ...spinners,
    Box,
    MiniSelect,
  },
  data() {
    return {
      ranks: [],
      loadingTable: true,
      months: [
        { text: 'Janeiro', value: 'january' },
        { text: 'Fevereiro', value: 'february' },
        { text: 'Março', value: 'march' },
        { text: 'Abril', value: 'april' },
        { text: 'Maio', value: 'may' },
        { text: 'Junho', value: 'june' },
        { text: 'Julho', value: 'july' },
        { text: 'Agosto', value: 'august' },
        { text: 'Setembro', value: 'september' },
        { text: 'Outubro', value: 'october' },
        { text: 'Novembro', value: 'november' },
        { text: 'Dezembro', value: 'december' }
      ],
      selectedMonth: '',
    }
  },
  computed: {
    currentMonth() {
      const date = new Date();
      const currentMonthIndex = date.getMonth();
      return this.months[currentMonthIndex].value;
    }
  },
  async mounted() {
    this.selectedMonth = this.currentMonth

    await this.loadRank(this.selectedMonth)
  },
  methods: {
    async loadRank(month) {
      this.loadingTable = true

      await this.$http.get(`${urlApi}/dashboard/gestor/rank-instrutores?month=${month}`)
        .then((res) => {
          this.ranks = res.data.dados
        })
        .catch((error) => {
          this.launchToast('fa-exclamation', error.data.dados)
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    async updateModelValue(e) {
      if (e.target.value) {
        this.selectedMonth = e.target.value

        return await this.loadRank(e.target.value)
      }

      this.selectedMonth = this.currentMonth

      await this.loadRank(this.selectedMonth)
    }
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  flex: 1;
  min-width: 18.4375rem;
  min-height: 21.3125rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      margin: 0;
      font-size: 1.375rem;
      font-weight: 700;
      color: #202224;
    }
  }

  .loading {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .header {
      padding: 0 1rem 0.125rem 0.5rem;
      border-bottom: 0.03125rem solid #E2E2E2;

      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        font-size: 0.5rem;
        font-weight: 600;
        color: #202224;
      }
    }

    .body {
      max-height: 20rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 3px;
      }

      .list-item {
        padding: 0.25rem 0.5rem;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        cursor: pointer;

        .name {
          flex: 1;
          font-size: 0.75rem;
          font-weight: 600;
          color: #202224;
        }

        .count {
          padding: 0.25rem;
          background: #fff;
          border: 0.5px solid #E2E2E2;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 0.625rem;
          font-weight: 700;
          color: #636466;
        }

        i {
          width: 2.125rem;
          height: 2.125rem;
          font-size: 2.125rem;
        }

        &:hover {
          background: #EAF0FF;
        }
      }

      @media only screen and (max-width: 780px) {
        max-height: 21.3125rem;
      }

      @media only screen and (min-width: 768px) and (max-width: 1280px) {
        max-height: 49rem;
      }
    }

    .empty-body {
      display: flex;
      align-items: center;
      justify-content: center;

      font-size: 0.75rem;
      font-weight: 700;
      color: #202224;
    }
  }
}
</style>
